import { Search, Star, MousePointerClick, PhoneMissed, MessageSquare, BellOff, StarOff, UserX } from "lucide-react";
import { LEAKS } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const ICONS = { Search, Star, MousePointerClick, PhoneMissed, MessageSquare, BellOff, StarOff, UserX };

export const Leaks = () => (
    <section id="leaks" className="py-16 sm:py-24 lg:py-32" data-testid="leaks-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
            <SectionHeading
                chapter="01"
                kicker="The Leaks"
                title="Where local businesses quietly lose customers."
                lead="Most local businesses don't have a marketing problem — they have a leaking customer journey. Customers are searching, finding, calling and enquiring. They're just slipping away at one of these points."
                testid="leaks-heading"
            />
            <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {LEAKS.map((leak, i) => {
                    const Icon = ICONS[leak.icon];
                    return (
                        <Reveal key={leak.title} delay={(i % 4) * 0.08}>
                            <article
                                data-testid={`leak-card-${i}`}
                                className="group h-full rounded-2xl border border-brand-brown/10 bg-white p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-orange/40 hover:shadow-[0_20px_40px_-18px_rgba(53,24,13,0.25)]"
                            >
                                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-orange-tint text-brand-orange transition-colors duration-300 group-hover:bg-brand-orange group-hover:text-white">
                                    <Icon size={20} aria-hidden="true" />
                                </div>
                                <h3 className="mt-5 font-display text-lg font-bold text-brand-brown">{leak.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-brand-muted">{leak.text}</p>
                            </article>
                        </Reveal>
                    );
                })}
            </div>
            <Reveal delay={0.1}>
                <p className="mt-10 max-w-2xl border-l-2 border-brand-orange pl-5 font-display text-lg italic leading-relaxed text-brand-brown sm:text-xl">
                    033 Digital exists to close these leaks — not with more random marketing, but with one connected
                    system.
                </p>
            </Reveal>
        </div>
    </section>
);
